import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user_role");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("full_name");
    localStorage.removeItem("is_volunteer");
    // Redirect to login page
    navigate("/login");
    window.location.reload()
  }, [navigate]);

  return null; // No UI needed for the logout component
};

export default Logout;
